module.exports = __webpack_public_path__ + "static/media/mernChatApp.6ac3e178.PNG";